module.exports = __webpack_public_path__ + "media/A38.79543868.mp3";